/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { RegisterDeceasedService } from './services/register-deceased.service';
import { WarehouseLogisticsService } from './services/warehouse-logistics.service';
import { ProcessesService } from './services/processes.service';
import { UndertakerService } from './services/undertaker.service';
import { ConstantService } from './services/constant.service';
import { DeliverDeceasedService } from './services/deliver-deceased.service';
import { PickupDeceasedService } from './services/pickup-deceased.service';
import { SearchService } from './services/search.service';
import { CalendarSearchService } from './services/calendar-search.service';
import { LocationsService } from './services/locations.service';
import { RoomsService } from './services/rooms.service';
import { WizardService } from './services/wizard.service';
import { UsersService } from './services/users.service';
import { BookingsService } from './services/bookings.service';
import { BookingTypesService } from './services/booking-types.service';
import { SlotsService } from './services/slots.service';
import { CsvImportService } from './services/csv-import.service';
import { ExternalCalendarService } from './services/external-calendar.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    RegisterDeceasedService,
    WarehouseLogisticsService,
    ProcessesService,
    UndertakerService,
    ConstantService,
    DeliverDeceasedService,
    PickupDeceasedService,
    SearchService,
    CalendarSearchService,
    LocationsService,
    RoomsService,
    WizardService,
    UsersService,
    BookingsService,
    BookingTypesService,
    SlotsService,
    CsvImportService,
    ExternalCalendarService,
    ApiConfiguration,
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params,
        },
      ],
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: ApiModule, @Optional() http: HttpClient) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575'
      );
    }
  }
}
